module.exports = __webpack_public_path__ + "img/check.3efafaa1.gif";